import React from 'react';
import {
  FiBarChart2,
  FiTrendingUp,
  FiTrendingDown,
  FiMapPin,
  FiUsers,
  FiUser,
  FiDollarSign,
  FiMail,
  FiBell,
  FiRefreshCw,
  FiSearch,
  FiFolder,
  FiFileText,
  FiUpload,
  FiDownload,
  FiSettings,
  FiLock,
  FiTool,
  FiEdit2,
  FiTrash2,
  FiLogOut,
  FiCheckCircle,
  FiXCircle,
  FiX,
  FiHelpCircle,
  FiGlobe,
  FiTarget,
  FiBriefcase,
  FiSave,
  FiClipboard,
  FiBook,
  FiSmartphone,
  FiMap,
  FiZap,
  FiStar,
  FiEdit3,
  FiFilter,
  FiArrowLeft,
  FiArrowRight,
  FiPlus,
  FiEye,
  FiEyeOff,
  FiSend,
  FiPrinter,
  FiCalendar,
  FiClock,
  FiAward,
  FiShield,
  FiInfo,
  FiCheck,
  FiAlertTriangle,
  FiExternalLink,
  FiChevronDown,
  FiSun,
  FiMoon,
  FiChevronLeft,
  FiChevronRight,
  FiCornerUpLeft,
  FiHome,
  FiDatabase,
  FiTag,
  FiAperture,
  FiAtSign,
  FiCoffee,
  FiUserCheck,
  FiPaperclip,
  FiList,
  FiMenu,
  FiCircle
} from 'react-icons/fi';
import {
  FaGraduationCap,
  FaTrophy,
  FaCrown,
  FaMedal,
  FaLightbulb,
  FaRocket,
  FaFolderOpen,
  FaDice,
  FaDoorOpen,
  FaLandmark,
  FaRegStar,
  FaCircle,
  FaPalette,
  FaSpinner,
  FaCopy
} from 'react-icons/fa6';

const ICONS = {
  'bar-chart': FiBarChart2,
  'trending-up': FiTrendingUp,
  'trending-down': FiTrendingDown,
  'map-pin': FiMapPin,
  users: FiUsers,
  user: FiUser,
  dollar: FiDollarSign,
  mail: FiMail,
  bell: FiBell,
  refresh: FiRefreshCw,
  search: FiSearch,
  folder: FiFolder,
  'folder-open': FaFolderOpen,
  'file-text': FiFileText,
  upload: FiUpload,
  download: FiDownload,
  settings: FiSettings,
  lock: FiLock,
  tool: FiTool,
  edit: FiEdit2,
  pencil: FiEdit3,
  trash: FiTrash2,
  logout: FiLogOut,
  'check-circle': FiCheckCircle,
  'x-circle': FiXCircle,
  close: FiX,
  help: FiHelpCircle,
  globe: FiGlobe,
  target: FiTarget,
  briefcase: FiBriefcase,
  save: FiSave,
  clipboard: FiClipboard,
  book: FiBook,
  smartphone: FiSmartphone,
  map: FiMap,
  zap: FiZap,
  star: FiStar,
  'star-outline': FaRegStar,
  filter: FiFilter,
  'arrow-left': FiArrowLeft,
  'arrow-right': FiArrowRight,
  plus: FiPlus,
  eye: FiEye,
  'eye-off': FiEyeOff,
  send: FiSend,
  printer: FiPrinter,
  calendar: FiCalendar,
  clock: FiClock,
  award: FiAward,
  shield: FiShield,
  info: FiInfo,
  alert: FiAlertTriangle,
  warning: FiAlertTriangle,
  check: FiCheck,
  'external-link': FiExternalLink,
  'chevron-down': FiChevronDown,
  'sun': FiSun,
  'moon': FiMoon,
  'chevron-left': FiChevronLeft,
  'chevron-right': FiChevronRight,
  'corner-up-left': FiCornerUpLeft,
  home: FiHome,
  database: FiDatabase,
  tag: FiTag,
  aperture: FiAperture,
  'at-sign': FiAtSign,
  coffee: FiCoffee,
  'user-check': FiUserCheck,
  paperclip: FiPaperclip,
  list: FiList,
  'menu': FiMenu,
  circle: FiCircle,
  'graduation-cap': FaGraduationCap,
  trophy: FaTrophy,
  crown: FaCrown,
  medal: FaMedal,
  'medal-gold': FaMedal,
  'medal-silver': FaMedal,
  'medal-bronze': FaMedal,
  lightbulb: FaLightbulb,
  rocket: FaRocket,
  dice: FaDice,
  door: FaDoorOpen,
  landmark: FaLandmark,
  'status-green': FaCircle,
  'status-amber': FaCircle,
  palette: FaPalette,
  spinner: FaSpinner,
  'copy': FaCopy
};

const ICON_COLORS = {
  'medal-gold': '#eab308',
  'medal-silver': '#94a3b8',
  'medal-bronze': '#b45309',
  'status-green': '#10b981',
  'status-amber': '#f59e0b'
};

function Icon({ name, size = '1em', color, className = '', style }) {
  const Comp = ICONS[name];
  if (!Comp) {
    return null;
  }
  return (
    <Comp
      size={size}
      color={color || ICON_COLORS[name]}
      className={className}
      style={{ verticalAlign: '-0.125em', ...style }}
      aria-hidden="true"
    />
  );
}

export default Icon;